<template>
  <div
    class="
      flex
      h-12
      shadow-md
      rounded-lg
      border border-gray-100
      text-bnb-brown
      overflow-hidden
    "
  >
    <button
      @click="shareApp"
      class="
        flex-1
        bg-gradient-to-r
        from-gray-100
        rounded-l-lg
        flex
        tracking-tight
        font-semibold
        items-center
        justify-center
      "
    >
      Share App
      <img alt="image" class="h-7 ml-2" src="@/assets/icons/shareapp.svg" />
    </button>
    <hr class="w-0.5 h-full bg-gray-200" />
    <button
      @click="downloadMenu"
      class="
        flex-1
        rounded-r-lg
        bg-gradient-to-l
        from-gray-100
        flex
        tracking-tight
        items-center
        font-semibold
        justify-center
      "
    >
      Download Menu<img
        alt="image"
        class="h-7 ml-2"
        src="@/assets/icons/menuDownloadLounge.svg"
      />
    </button>
  </div>
</template>

<script>
import { Toast } from "@capacitor/toast";
import { Browser } from "@capacitor/browser";
import { Share } from "@capacitor/share";
export default {
  methods: {
    downloadMenu() {
      Toast.show({ text: "Downloading Menu...", position: "bottom" });
      var url = this.$store.state.appDetails?.menuLink?.link;
      Browser.open({ url, toolbarColor: "#af803e" });
    },
    shareApp() {
      Toast.show({ text: "Loading...", position: "bottom" });
      var phone = this.$store.state.phone1;
      var email = this.$store.state.email;
      var android = this.$store.state.appDetails?.update?.androidLink;
      var ios = this.$store.state.appDetails?.update?.iosLink;
      Share.share({
        title: "BandB App Share",
        text:
          "Hi! Check out the Buns and Batter App. Android(" +
          android +
          "), iOS(" +
          ios +
          "). Knead Anything? Call us (" +
          phone +
          ") or Send us an email (" +
          email +
          ").",
        dialogTitle: "BandB App Share",
      })
        .then(() => {
          this.$toast.show("Thank You for sharing our app", {
            position: "bottom",
            duration: 5000,
          });
        })
        .catch((error) =>
          this.$toast.warning(error, {
            position: "bottom",
            duration: 2000,
          })
        );
    },
  },
};
</script>
